export class OrganisationGroupReferenceModel {
    public organisationGroupCode: string;
    public organisationGroupName: string;
    public organisationId: string;
}